import React from "react";
import styles from "./Footer.module.scss";
import bg from "../Bottom.svg";

export const Footer: React.FunctionComponent = () => {
  return (
    <footer className={styles.footer}>
      <div
        className={styles.border}
        style={{
          backgroundImage: `url(${bg})`,
        }}
      />
      <div className={styles.body}></div>
    </footer>
  );
};
